<template>
  <fn-panel-image
    column-size="6"
    class="panel--error"
  >
    <template #image>
      <img
        :src="imageUrl"
        class="show-m error-main-image"
        :alt="image.alt || ''"
      />
    </template>
    <template #default>
      <div
        id="error-intro"
        class="error-panel"
      >
        <img
          class="error-image"
          src="@/assets/img/lupe_404.png"
        />
        <fn-headline
          v-if="title"
          type="h1"
          size="hero"
          class="error-headline"
        >
          {{ title }}
        </fn-headline>
        <p
          v-if="description"
          class="error-text"
          v-html="description"
        />
        <fn-button
          v-if="!isAppview"
          to="/"
          secondary
        >
          {{ $t('pages.error.buttons.base') }}
        </fn-button>
      </div>
    </template>
  </fn-panel-image>
</template>

<script>
import { mapState } from 'pinia';
import { getImageUrl } from '@/utils/images';

export default {
  props: {
    image: {
      type: [Object, String],
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(useMainStore, {
      isAppview: 'isAppview',
    }),

    imageUrl() {
      return getImageUrl(this.image);
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  &-main-image {
    width: 100%;
  }

  &-panel {
    padding: 2 * $pad 1.5 * $pad;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    align-self: center;
    width: 100%;
  }

  &-image {
    display: block;
    align-self: center;
    margin-bottom: $space;
    position: relative;
    left: -$space;
  }

  &-headline {
    display: block;
    width: 100%;
    text-align: center;
  }

  &-text {
    margin-bottom: $space;
  }
}
</style>
